import { render } from "./Vactotaal.vue?vue&type=template&id=4a88389c&scoped=true"
import script from "./Vactotaal.vue?vue&type=script&lang=js"
export * from "./Vactotaal.vue?vue&type=script&lang=js"

import "./Vactotaal.vue?vue&type=style&index=0&id=4a88389c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a88389c"]])

export default __exports__